module.exports = __webpack_public_path__ + "media/images/landing/illust/person-35d18d229419cb41e12a499109e5f348.png";